<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";

	export let data = [];
	export let changeFetchParams;

	function navigateToDetails(vehicleId) {
		navigate(`/issues/case-management/rejected/${vehicleId}`);
	}

	// handle parent sort event
	function handleSort({ detail: { column, direction } }) {
		changeFetchParams({ sortCol: column, sortDir: direction });
	}
</script>

<CustomTable
	columns={[
		{
			label: "Case Closed On",
			key: "rejectedAt",
			type: "date",
			sortCol: 1,
		},
		{ label: "Investigator", key: "investigator" },
		{
			label: "Reason",
			key: "rejectedReason",
			type: "status",
			options: "damages",
		},
		{
			label: "Case Origin",
			key: "caseOrigin",
			type: "masterdata",
		},
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "view",
		},
	]}
	rows={data}
	emptyMessage="There are currently no cases to display."
	on:sort={handleSort}
/>
